<template>
	<page style="background: #fff">
		<c-form ref="form">
			<c-form-item label="送修资产" required>
				<c-select ref="assetsSelect" name="asset_id" :disabled="!!id" async @search="searchAssets"></c-select>
			</c-form-item>
			<c-form-item label="送修人" required>
				<c-select ref="userSelect" name="sender_user_id" async @search="searchUser"></c-select>
			</c-form-item>
			<c-form-item label="送修时间" required>
				<c-datetime name="repair_time" time-accuracy="min" format="yyyy-MM-dd hh:mm"></c-datetime>
			</c-form-item>
			<c-form-item label="维修类型" required>
				<c-select name="repair_type" :options="repairTypeDic"></c-select>
			</c-form-item>
			<c-form-item label="故障描述" required>
				<c-input type="textarea" name="repair_summary"></c-input>
			</c-form-item>
			<c-form-item label="备注">
				<c-input type="textarea" name="remark"></c-input>
			</c-form-item>
		</c-form>

		<template #button>
			<c-button size="form" color="main" @click="submitHandle">确认提交</c-button>
		</template>
	</page>
</template>

<script>
	import {mapState} from 'vuex'

	export default {
		props: {
			id: String
		},

		data() {
			return {
			}
		},

		computed: {
			...mapState(['userInfo', 'repairTypeDic'])
		},

		mounted() {
			if (this.id) {
				this.request({
					url: '/asset_repair_record/detail',
					data: {
						id: this.id
					},
					success: data => {
						this.$refs.form.set(data);
						this.$refs.assetsSelect.setValueData([{
							name: `${data.asset_code} - ${data.asset_name}`,
							value: data.asset_id
						}]);
						this.$refs.userSelect.setValueData([{
							name: data.sender_user_name,
							value: data.sender_user_id
						}]);
					}
				})
			} else {
				this.$refs.userSelect.setValueData([{
					name: this.userInfo.user_realname,
					value: this.userInfo.id
				}]);
			}
		},

		methods: {
			searchAssets(keyword, resolve) {
				this.request({
					url: '/fixed_asset/list',
					data: {
						current_status: 1,
						status: [1],
						keyword,
                        pageSize:9999
					},
					success: data => resolve(data.map(item => {
                        return {
                            name: `${item.asset_name}-${item.asset_category}${item.asset_code ? '-' + item.asset_code : ''}`,
                            value: item.id
                        }
					}))
				});
			},

			searchUser(keyword, resolve) {
				this.request({
					url: '/system/options',
					data: {
						options_code: 'SYSUSER',
						keyword
					},
					success: data => resolve(data)
				});
			},

			submitHandle() {
				this.$refs.form.submit({
					url: this.id ? '/asset_repair_record/edit' : '/asset_repair_record/add',
					rule: {
						asset_id: '请选择送修资产',
						sender_user_id: '请选择送修人',
						repair_time: '请选择送修时间',
						repair_type: '请选择维修类型',
						repair_summary: '请填写维修内容'
					},
					dataFormatter: data => {
						data.id = this.id;
						return data;
					},
					success: (data, res) => {
						this.$message({
							message: '提交成功',
							mask: true
						});
						setTimeout(() => {
							if (this.id) {
								this.mp.navigateBack();
							} else {
								this.mp.redirectWeb('/assets/repair/detail', {id: res});
							}
						}, 1000);
					}
				})
			}
		}
	}
</script>

<style lang="stylus" scoped>
</style>